export default __webpack_public_path__ + "static/media/CNo.20-1.5e6ab266.jpg";